import { CountryCode } from '@qred/shared-enums';
import { formatOrganizationNumber } from '~/helpers/formatters.helper';
import { normalizeOrgNumberHelper } from '~/helpers/normalizeOrgNumber.helper';
import { getCookieValue } from '~/helpers/utils';
import { ICardApplicationForm } from '~/interfaces/cardApplication';
import {
  CardApplicationDTO,
  CardDataPointsShared,
} from '~/schemas/DTO/cardApplicationSchemas';

// TODO: do we still need to pass currentForm to this function?
export const mapToCardApplicationForm = (
  data: CardApplicationDTO,
  currentForm: ICardApplicationForm
): ICardApplicationForm => {
  let applicant = { ...currentForm.applicant };
  if (data.applicant) {
    const { firstName, lastName, ...restOfApplicantFromData } = data.applicant;
    const fullName = `${firstName || ''} ${lastName || ''}`.trim();
    applicant = {
      ...applicant,
      ...restOfApplicantFromData,
      ...(fullName && { fullName }),
    };
  }

  return {
    ...currentForm,
    applicant,
    applicationUuid: data.applicationUuid,
    organizationNumber: formatOrganizationNumber(
      data.organization.organizationNumber || ''
    ),
    companyName: data.organization.companyName,
    companyAddress: data.organization.companyAddress,
    companyType: data.organization.companyType || '',
    purposeOfCard: data.purposeOfCard,
    cardPurposeManual: data.cardPurposeManual,
    sessionId: data.sessionId,
    applicationId: data.applicationId,
    qCode: data.qCode,
    userCode: data.userCode,
    turnover: data.turnover,
  };
};

export const mapToCardApplicationDTO = ({
  form,
  market,
  currentStepNumber,
  currentStepCompleted,
  finalized,
  shouldPostApplication,
  clientId,
  isAuthenticated,
  dataPointsShared,
}: {
  form: ICardApplicationForm;
  market: CountryCode;
  currentStepNumber: number;
  currentStepCompleted: boolean;
  finalized: boolean;
  shouldPostApplication: boolean;
  clientId?: number;
  isAuthenticated: boolean;
  dataPointsShared: CardDataPointsShared;
}): CardApplicationDTO => {
  const {
    organizationNumber,
    companyType,
    companyName,
    companyAddress,
    applicant,
    ...rest
  } = form;

  const { fullName, ...applicantRest } = applicant;

  return {
    applicant: {
      ...applicantRest,
      ...(fullName && {
        firstName: fullName.split(' ')[0],
        lastName: fullName.split(' ').slice(1).join(' '),
      }),
    },
    organization: {
      organizationNumber: organizationNumber
        ? normalizeOrgNumberHelper(organizationNumber, market)
        : '',
      companyType: companyType || undefined,
      companyName: companyName || undefined,
      companyAddress: companyAddress || undefined,
    },
    completedStep: currentStepCompleted
      ? currentStepNumber
      : currentStepNumber - 1,
    currentStep: currentStepNumber,
    market,
    finalized,
    clientId,
    dataPointsShared,
    ...(shouldPostApplication && {
      trafficCookie: getCookieValue('_ga') || '',
    }),
    ...rest,
    applicantAuthenticated: isAuthenticated,
  };
};
